module.exports = __webpack_public_path__ + "static/media/ic_popup_kyc_underprocess.3ccd76a1.svg";